import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ReservationState {
  reservationId?: string;
  restaurantId?: string;
  restaurantName: string;
  reservationTime: string;
  reservationDate: string;
  partySize: number;
  timeRemainingLabel: string;
  expiresAtMs?: number;
  // Countdown cutoff time; should be reservation.lock_at in UTC ms
  lockAtMs?: number;
  // Localized human label for lock_at (e.g., "Oct 3, 7:30 PM")
  lockAtLabel?: string;
  // Whether countdown should actively tick; false when > 90 minutes away
  countdownActive?: boolean;
  phoneNumber?: string;
  guestName?: string;
  order?: any;
  orderItems: Array<{
    id?: string;
    name?: string;
    quantity?: number;
    priceCentsPerUnit?: number;
    modifiers?: any;
  }>; // normalized list for UI
  logo?: string;
  banner?: string;
  loaded?: boolean;
  // True when an order has just been confirmed via OTP (used to gate success page)
  orderConfirmed?: boolean;
}

const initialState: ReservationState = {
  reservationId: undefined,
  restaurantId: undefined,
  restaurantName: "Aerlume",
  reservationTime: "2:00PM",
  reservationDate: "Monday, October 3, 2025",
  partySize: 4,
  timeRemainingLabel: "32:27",
  expiresAtMs: undefined,
  lockAtMs: undefined,
  lockAtLabel: undefined,
  countdownActive: false,
  phoneNumber: "",
  guestName: "",
  orderItems: [],
  logo: "",
  banner: "",
  loaded: false,
  orderConfirmed: false,
};

const reservationSlice = createSlice({
  name: "reservation",
  initialState,
  reducers: {
    updateReservation(state, action: PayloadAction<Partial<ReservationState>>) {
      Object.assign(state, action.payload);
    },
    setReservationId(state, action: PayloadAction<string | undefined>) {
      state.reservationId = action.payload;
    },
    clearReservation(state) {
      Object.assign(state, initialState);
    },
    setPartySize(state, action: PayloadAction<number>) {
      state.partySize = action.payload;
    },
  },
});

export const {
  updateReservation,
  clearReservation,
  setPartySize,
  setReservationId,
} = reservationSlice.actions;
export default reservationSlice.reducer;
